import { Link } from "react-router-dom";
import { PRESENTATIONS } from "./presentationsCatalog";

const Presentations = () => {
  return (
    <div className="p-4 md:p-6 max-w-3xl">
      <h1 className="text-2xl text-[#d59106] mb-2">Apresentações</h1>
      <p className="text-orange-100/70 text-sm mb-6">
        Materiais internos para sócios. Acesso restrito a admin master (mesmo gate dos Logs).
      </p>
      <ul className="space-y-3">
        {PRESENTATIONS.map((item) => (
          <li
            key={item.id}
            className="border border-[#b47c06]/60 rounded-lg p-4 bg-black/20"
          >
            <div className="flex flex-col gap-2 sm:flex-row sm:items-start sm:justify-between">
              <div>
                <h2 className="text-lg text-orange-100">{item.title}</h2>
                <p className="text-xs text-orange-100/50 mt-1">{item.date}</p>
                <p className="text-sm text-orange-100/70 mt-2">{item.description}</p>
              </div>
              <Link
                to={`/manafix/presentations/${item.id}`}
                className="shrink-0 self-start mt-2 sm:mt-0 px-3 py-1.5 rounded border border-[#d59106] text-[#d59106] hover:bg-[#d59106] hover:text-black text-sm"
              >
                Abrir
              </Link>
            </div>
          </li>
        ))}
      </ul>
      {PRESENTATIONS.length === 0 ? (
        <p className="text-orange-100/60 text-sm">Nenhuma apresentação cadastrada.</p>
      ) : null}
    </div>
  );
};

export default Presentations;
